import { render, staticRenderFns } from "./PublicationHome.vue?vue&type=template&id=ae704f8a&scoped=true&"
import script from "./PublicationHome.vue?vue&type=script&lang=js&"
export * from "./PublicationHome.vue?vue&type=script&lang=js&"
import style0 from "./PublicationHome.vue?vue&type=style&index=0&id=ae704f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae704f8a",
  null
  
)

export default component.exports